import React from 'react'
import { ComponentData } from '../data/ComponentContext'

function WeightInput({ className, displayErrors }) {

  const { weight, setWeight, weightIsValid } = ComponentData()

  return (
    <div className={displayErrors && !weightIsValid ? className + ' error' : className}>
      <p>Masse</p>
      <div className="input-fields">
        <div>
          <input type="number" value={weight} onChange={(e) => {
            if (e.target.value >= 0) {
              setWeight(e.target.value)
            }
          }} />
          <span className='unit-label'>g</span>
        </div>
      </div>

      {displayErrors && !weightIsValid ? <p className='error'>Masse darf nicht leer oder "0" sein!</p> : null}
    </div>
  )
}

export default WeightInput